import React from "react";
import PropTypes from "prop-types";
import Button from "react-bootstrap/Button";
import styled, { withTheme } from "styled-components";

const StyledSecondaryBtn = styled(Button)`
  color: ${(props) => props?.theme?.white};
  background-color: ${(props) => props?.theme?.gray};
  border-color: ${(props) => props?.theme?.gray};
  &:hover,
  &:focus {
    color: ${(props) => props?.theme?.white};
    background-color: ${(props) => props?.theme?.dimGray};
    border-color: ${(props) => props?.theme?.dimGray};
  }
  &:focus {
    box-shadow: ${(props) => props?.theme?.secondaryShadow};
  }
  &:disabled,
  :not(:disabled):not(.disabled):active,
  :not(:disabled):not(.disabled).active,
  .show > .dropdown-toggle {
    color: ${(props) => props?.theme?.gray};
    background-color: ${(props) => props?.theme?.gainsboro};
    border-color: ${(props) => props?.theme?.gainsboro};
  }
  &:not(:disabled):not(.disabled):active:focus,
  .show > .dropdown-toggle:focus {
    box-shadow: ${(props) => props?.theme?.secondaryShadow};
  }
`;

const SecondaryButton = (props) => {
  const { text, size } = props;

  return (
    <StyledSecondaryBtn {...props} size={size}>
      {text || props.children}
    </StyledSecondaryBtn>
  );
};

SecondaryButton.propTypes = {
  size: PropTypes.oneOf(["lg", "", "sm"]),
};

export default withTheme(SecondaryButton);
